import { action } from 'satcheljs';
import { CalendarEventsLoadingState } from 'owa-calendar-events-store';
import { CalendarId } from 'owa-calendar-cache';

export const setCalendarLoadState = action(
    'setCalendarLoadState',
    (calendarId: CalendarId, loadingState: CalendarEventsLoadingState) => ({
        calendarId,
        loadingState,
    })
);
